import {Fragment, useEffect, useState} from 'react';

import {ProductService as Service} from './ProductService';
import {UnitService} from '../don-vi-tinh/UnitService';
import {TaxService} from '../thue-suat/TaxService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import {useImExExcel} from '../../../shared/hooks/ImExExcel';
import {FormatDisplay} from '../../../shared/format';
import {ConfirmDialogService} from '../../../AppConfirmDialog';
import {useDialogChangeTax} from './item/DialogChangeTax';
import  EventEmitter  from '../../../utils/EventEmitter';  
export const List = () => {

  const header = 'Hàng hóa, dịch vụ';
  const dataKey = 'id';
  const [displaySelectProduct, setDisplaySelectProduct] = useState(null);
  const [units, setUnits] = useState([]);
  const [taxs, setTaxs] = useState([]);
  const [manyActions, setManyActions] = useState([]);
  const [productsChange, setProductsChange] = useState([]);
  useEffect(() => {
    UnitService.getList({
      skipCount: 0,
      maxResultCount: 1000,
    }).then(({items}) => {
      const _units = [];
      items.forEach(item => {
        _units.push({value: item.id, label: item.name});
      });
      setUnits(_units);
    });
    TaxService.getList({}).then(({items}) => {
      const _taxs = [];
      items.forEach((item) => {
        _taxs.push({value: item.id, label: item.name});
      });
      setTaxs(_taxs);
    });
  }, []);

  useEffect(() => {
    const eventsChangeSerial = EventEmitter.addListener("changeTaxs", changeTaxs);
    return () => {
      eventsChangeSerial.removeListener("changeTaxs", changeTaxs);
    }
  });

  const changeTaxs = (changeTaxsData) => {
    Service.updateChangeTax(changeTaxsData).then(res => {
      refreshLazyData();
     });
  }
  
  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'code', header: 'Mã hàng hóa', width: 200, matchMode: 'contains'},
      {field: 'name', header: 'Tên hàng hóa', minWidth: 220, matchMode: 'contains'},
      {field: 'taxId', header: 'Thuế suất', width: 160, matchMode: 'contains', filterType: 'multiselect', filterOptions: taxs, dataType: 'custom', customCell(rowData: any): any {
        return  rowData.taxName;
        }
      },
      {
        field: 'price', header: 'Giá bán', width: 160, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return FormatDisplay.number(rowData.price, {maximumSignificantDigits: `${rowData.price}`.length})
        }, style: {justifyContent: 'end'}
      },
      {field: 'unit', header: 'Đơn vị tính', width: 160,  matchMode: 'contains'}
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });
  useEffect(() => {
    const actionsOther = [];
    actionsOther.push({label: 'Thay đổi thuế suất hàng loạt', icon: 'p-button-icon p-c pi pi-user-edit', className: 'iam-toolbar',command: showChangeTaxDialog});
    setManyActions(actionsOther);
    refreshToolbar();
  }, [selectedItems]); // eslint-disable-line react-hooks/exhaustive-deps
  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '60rem',
    fields: [
      {field: 'code', header: 'Mã hàng hóa', required: true, uppercase: true, InputTextProps: {maxLength: 50}, className: 'md:col-12'},
      {field: 'name', header: 'Tên hàng hóa', required: true, InputTextProps: {maxLength: 500}, className: 'md:col-12'},
      {field: 'unitId', header: 'Đơn vị tính', type: 'Dropdown', DropdownProps: {options: units, filter: true}, className: 'md:col-6'},
      {field: 'taxId', header: 'Thuế suất', type: 'Dropdown', DropdownProps: {options: taxs, filter: true}, className: 'md:col-6'},
      {field: 'price', header: 'Giá bán', type: 'InputNumber', InputNumberProps: {min: 0, maxFractionDigits: 6}, className: 'md:col-12'}
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderImExExcel, download, showImportDialog} = useImExExcel({
    exportTemplate: () => {
      return Service.downloadExcelTemplate();
    },
    exportExcel: (params) => {
      return Service.downloadExcel(params);
    },
    exportExcelFileName: 'danh-muc-hang-hoa-dich-vu',
    importExcel: (data) => {
      return Service.uploadExcel(data);
    },
    reloadLazyData
  });

  const {renderToolbar, refreshToolbar} = useToolbar({
    dataKey, create,
    update: (item) => {
      Service.get(item[dataKey]).then(data => {
        update(data);
      });
    },
    clone: (item) => {
      Service.get(item[dataKey]).then(data => {
        clone(data);
      });
    },
    reloadLazyData, selectedItems,
    showImportDialog,
    exportExcel: download, dataTableParams,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    otherActions: [
      ...manyActions, 
    ]
  });

  const onAddSelectedItems = (items) => {
    let InvoiceIdArray;
    if (Array.isArray(items) && items.length) {
      InvoiceIdArray = items.map(({id}) => id);
    }  
    
    if (!InvoiceIdArray || InvoiceIdArray.length < 1) {
     ConfirmDialogService.showInvalid('Bạn cần chọn hàng hóa trước khi sửa');
     return;
    }
   
    // sign({
    //  "CommandName": "SignInvoices",
    //  "InvoiceIdArray": InvoiceIdArray
    // });
  }

  const {renderChangeTax, showChangeTaxDialog} = useDialogChangeTax({
    selectedItems,
    taxs 
  });


  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
      {renderImExExcel()}
      {renderChangeTax()}
    </Fragment>
  )
}
